var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedicineShortage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 6.98659L23.3723 20.6813H7.62773L15.5 6.98659ZM15.5 2.78659L4 22.7866H27L15.5 2.78659ZM16.5455 17.5234H14.4545V19.6287H16.5455V17.5234ZM16.5455 11.2076H14.4545V15.4182H16.5455V11.2076Z",
    fill: "#F0483E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicineShortage);
export default __webpack_public_path__ + "static/media/MedicineShortage.894d47f9b8a4f408d0247ea8b4c8dac4.svg";
export { ForwardRef as ReactComponent };